<template>
	<div class="country-flag-icon">
		<span v-if="countryCode" :class="countryCode">—</span>
		<span v-else>—</span>
	</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
	countryCode: { type: String, required: false, default: "" },
});

const countryCode = computed(() =>
	props.countryCode ? "fi fi-" + props.countryCode.toLowerCase() : ""
);
</script>

<style lang="scss">
.country-flag-icon {
	display: inline-block;
	margin-right: 2px;
}
</style>
